import React, { useMemo, useState } from 'react';
import {
  DefaultQueryParams,
  getAmountWithCurrency,
  parseNumberByPrecision,
  parseQuery,
  RightContainer,
  TopWinnersContainer,
  useTranslation,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { applicationStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { LiveBetsWrapper } from './liveBetsWrapper';
import { CurrentAndTopWinnersItem } from '../topWinnersItem';
import { BetHistoryWrapper } from './betHistoryWrapper';
import { bonusIslandStore } from '../../../store/bonusIslandStore';
import { getBonusIslandImageSource, useUpdateEffect } from '../../../helpers';
import { AppDefaultValuesEnum } from '../../../enums';
import { BonusIslandRow } from '../../../components/common/bonusIsland/bonusIslanRow';
import { gameLiveConnection } from '../../../services/GameConnection';

const startCoinAnimation = () => {
  const moneyWr = document.createElement('div');
  moneyWr.classList.add('money-animation-wr');
  const moneyInner = document.createElement('div');
  moneyInner.classList.add('money-animation-inner');

  moneyWr.appendChild(moneyInner);

  document.querySelector('.bonus-island-wr')?.appendChild(moneyWr);

  const timeOut = setTimeout(() => {
    document.querySelectorAll('.money-animation-wr').forEach((el) => {
      if (!el.classList.contains('active')) {
        el.classList.add('active');
      }
    });
    clearTimeout(timeOut);
  }, 100);

  setTimeout(() => {
    moneyWr.remove();
  }, 2000);
};

const RightColumn = observer(() => {
  const rightContainerTabs = useMemo(
    () => [{ name: 'LIVE_BETS' }, { name: 'HISTORY', isBetHistory: true }, { name: 'TOP_WINNERS' }],
    []
  );
  const t = useTranslation();
  const query = parseQuery(window.location.search);
  const lang = query[DefaultQueryParams.Culture] || AppDefaultValuesEnum.LANGUAGE;
  const [winAmountState, setWinAmountState] = useState(0);

  const { ranges: currentRanges, liveUpdateData, setIsBonusIslandOpen } = bonusIslandStore;
  const { currencyCode, _currencySymbol: currency, userId } = userInfoStore;
  const { ranges = [] } = currentRanges;

  const { userId: liveUpdateDataUserId, winAmount } = liveUpdateData || {};

  const isChangePlacesOfAmountAndCurrencyCode = getAmountWithCurrency({
    isReturnPreValue: true,
    currencyCode: currency,
    currencyToShow: currencyCode,
  });

  useUpdateEffect(() => {
    if (+userId === +liveUpdateDataUserId && ranges?.length) {
      startCoinAnimation();
      if (winAmount) {
        setWinAmountState(parseNumberByPrecision(1, winAmount));
        gameLiveConnection.getBalance();
        setTimeout(() => {
          setWinAmountState(0);
        }, 2000);
      }
    }
  }, [liveUpdateData, userId]);

  const rightContainerTabsContainers = useMemo(
    () => [
      <LiveBetsWrapper />,
      <BetHistoryWrapper />,
      <TopWinnersContainer
        renderCurrentOrTopWinnerItem={(betData, index) => (
          <CurrentAndTopWinnersItem betData={betData} key={betData?.id || index} />
        )}
      />,
    ],
    []
  );

  return (
    <RightContainer
      hasChat
      hasFreeBets
      haveDarkMode
      setWinColor
      hasAvatarsBlock
      userImageSrc=''
      tabs={rightContainerTabs}
      onTabChange={() => {}}
      headerNames={['id', 'amount']}
      tabContainers={rightContainerTabsContainers}
    >
      {userId && Object.keys(bonusIslandStore.ranges)?.length && !applicationStore.isDemo ? (
        <BonusIslandRow
          t={t}
          handleOpenBonusIsland={setIsBonusIslandOpen}
          imageSrc={getBonusIslandImageSource(lang)}
          currencyCode={currencyCode}
          winAmount={winAmountState}
          winText={t('WIN')}
          isChangePlacesOfAmountAndCurrencyCode={isChangePlacesOfAmountAndCurrencyCode}
        />
      ) : (
        <></>
      )}
    </RightContainer>
  );
});

export default RightColumn;
